const config = {
  siteName: "Skip A Pay",
  hideSidebar: 992,
  server: "https://skipapay-api.zeabur.app/",
  // server: "https://skipapay-api.vercel.app/",
  // server: "http://localhost:3001/",
};
export default config;
